<template>
  <div class="ticket-main-section-right-column flex-shrink-1 pt-4 px-3"
    :class="{ 'sidebar-closed': sidebarSection === null }">
    <!-- Top section -->
    <div class="top-section">
      <h4 class="mb-1">{{ status.label }}</h4>
      <hr>
      <!-- Edit properties -->
      <!--      <h5 class="subtitle mb-4">Properties</h5>-->
      <div class="property-editor">

        <!-- Tags -->
        <div class="form-group mb-3">
          <label for="status">Tags</label>
          <v-select :options="tagTemplatesParsed" v-model="tags" multiple
            :disabled="isSaving || isLoadingTagTemplates"></v-select>
        </div>
        <!-- / Tags -->

        <!-- Status -->
        <div class="form-group mb-3">
          <label for="status">Status</label>
          <v-select v-model="status" label="label" :disabled="isSaving" :clearable="false"
            :options="ticketStatusDropdownOptions"></v-select>
        </div>
        <!-- / Status -->

        <!-- Priority -->
        <div class="form-group mb-3">
          <label for="priority">Priority</label>
          <v-select v-model="priority" label="label" :disabled="isSaving" :clearable="false"
            :options="ticketPriorityDropdownOptions"></v-select>
        </div>
        <!-- / Priority -->

        <!-- Difficulty -->
        <div class="form-group mb-3">
          <label for="difficulty">Difficulty</label>
          <v-select v-model="difficulty" label="label" :disabled="isSaving" :clearable="false"
            :options="ticketDifficultyDropdownOptions"></v-select>
        </div>
        <!-- / Difficulty -->

        <!-- Agent -->
        <div class="form-group mb-3">
          <div class="agent-label-wrapper">
            <div class="left">
              <label for="agent">Agent</label>
            </div>
            <div class="right">
              <a @click.prevent="transferOffice" class="transfer-office" href="#">Transfer office</a>
            </div>
          </div>
          <v-select v-model="agent_id" label="name" :disabled="isSaving" :reduce="agent => agent.id" :clearable="false"
            :options="agents"></v-select>
        </div>
        <!-- / Agent -->

        <!-- Source -->
        <div class="form-group mb-3">
          <label for="source">Source</label> 
          <v-select v-model="source" :disabled="isSaving" :clearable="false"
            :options="ticketSourceDropdownOptions"></v-select>
        </div>
        <!-- / Source -->

        <!-- Caused by ITG -->
        <!-- <div class="form-group mb-3">
          <label for="causedByItg">Caused by ITG Error?</label>

          <b-form-checkbox v-model="caused_by_itg_error" name="check-button" switch>
          </b-form-checkbox>
        </div> -->
        <!-- / Caused by ITG -->

        <!-- View Deleted -->
        <!--        <div class="form-group mb-3">-->
        <!--          <label for="viewDeleted">View Deleted Notes?</label>-->

        <!--          <b-form-checkbox v-model="show_deleted" name="check-button" switch>-->
        <!--          </b-form-checkbox>-->
        <!--        </div>-->
        <!-- / View Deleted -->

      </div>
      <!-- / Edit properties -->
    </div>
    <!-- / Top section -->
    <!-- Bottom section -->
    <div class="bottom-section pt-3 pb-3">
      <a href="#" @click.prevent="save" class="btn btn-itg-dark btn-block"
        :class="{ 'disabled': (!hasUnsavedChanges || isSaving) }">
        <span v-if="!isSaving">Apply Changes</span>
        <span v-if="isSaving">Saving...</span>
      </a>
    </div>
    <!-- / Bottom section -->
  </div>
</template>

<script>
import Forms from "../../../../mixins/Forms";
import Tickets from "../../../../mixins/Tickets";
import axios from 'axios';
import { mapGetters, mapActions } from "vuex";

export default {
  name: "TicketMainSectionRightColumn",
  mixins: [Forms, Tickets],
  data() {
    return {
      tags: null,
      status: null,
      priority: null,
      difficulty: null,
      agent_id: null,
      source: null,
      caused_by_itg_error: null,
      isSaving: false,
      serverErrors: []
    }
  },
  created() {
    // Set tags
    this.tags = this.ticketTagsParsed;

    // Set status
    this.status = _.find(this.ticketStatusDropdownOptions, {
      value: this.ticket.status
    });

    // Set priority
    this.priority = _.find(this.ticketPriorityDropdownOptions, {
      value: this.ticket.priority
    });

    // Set difficulty
    this.difficulty = _.find(this.ticketDifficultyDropdownOptions, {
      value: this.ticket.difficulty
    });

    // Set source
    this.source = _.find(this.ticketSourceDropdownOptions, {
      value: this.ticket.source
    });

    // Set agent id
    this.agent_id = this.ticket.agent_id;

    // Set caused by itg error?
    this.caused_by_itg_error = this.ticket.caused_by_itg_error;
  },
  computed: {
    ...mapGetters('ticketViewer', {
      ticket: 'ticket',
      agents: 'agents',
      sidebarSection: 'sidebarSection',
      showDeleted: 'showDeleted',
      isLoadingTagTemplates: 'isLoadingTagTemplates',
      tagTemplates: 'tagTemplates'
    }),

    show_deleted: {
      get() {
        return this.showDeleted;
      },
      set(val) {
        this.setShowDeleted(Boolean(val));
      }
    },

    ticketTagsParsed() {
      if (!this.ticket.tags || !this.ticket.tags.length) {
        return [];
      } else {
        return _.map(this.ticket.tags, 'name.en');
      }
    },

    tagTemplatesParsed() {
      if (!this.isLoadingTagTemplates && this.tagTemplates) {
        return _.map(this.tagTemplates, 'name');
      } else {
        return [];
      }
    },

    hasUnsavedChanges() {
      return (this.tags !== this.ticketTagsParsed) || (this.status.value !== this.ticket.status) || (this.priority.value !== this.ticket.priority) || (this.difficulty.value !== this.ticket.difficulty) || (this.agent_id !== this.ticket.agent_id) || (this.caused_by_itg_error !== this.ticket.caused_by_itg_error) || (this.source.value !== this.ticket.source);
    }
  },
  methods: {
    ...mapActions('ticketViewer', {
      updateTicketPropertySilently: 'updateTicketPropertySilently',
      setShowDeleted: 'setShowDeleted',
      loadTagTemplates: 'loadTagTemplates',
      setSidebarSection: 'setSidebarSection'
    }),

    transferOffice() {
      this.setSidebarSection('office-transfers');
    },

    save() {
      if (!this.hasUnsavedChanges) {
        return false;
      }

      let vm = this;
      vm.isSaving = true;

      axios.put(API_BASE + '/tickets/' + this.ticket.id, {
        tags: this.tags,
        status: this.status.value,
        priority: this.priority.value,
        difficulty: this.difficulty.value,
        agent_id: this.agent_id,
        caused_by_itg_error: this.caused_by_itg_error,
        source: this.source.value
      }).then(r => {
        vm.isSaving = false;
        vm.$notify.success({
          title: 'Success!',
          message: 'Ticket updated successfully'
        });
        vm.silentlyUpdateTicketWithNewProperties();
      }).catch(e => {
        vm.isSaving = false;
        vm.notifyErrors(e);
      });
    },

    silentlyUpdateTicketWithNewProperties() {
      let tags = [];
      _.each(this.tags, tag => {
        tags.push({
          name: {
            en: tag
          }
        });
      });
      this.updateTicketPropertySilently({
        property: 'tags',
        value: tags
      });
      this.updateTicketPropertySilently({
        property: 'status',
        value: this.status.value
      });
      this.updateTicketPropertySilently({
        property: 'priority',
        value: this.priority.value
      });
      this.updateTicketPropertySilently({
        property: 'difficulty',
        value: this.difficulty.value
      });
      this.updateTicketPropertySilently({
        property: 'agent_id',
        value: this.agent_id
      });
      this.updateTicketPropertySilently({
        property: 'source',
        value: this.source.value
      });
      this.updateTicketPropertySilently({
        property: 'caused_by_itg_error',
        value: this.caused_by_itg_error
      });
    }
  }
}
</script>

<style scoped lang="scss">
.ticket-main-section-right-column {
  width: 250px;
  min-width: 250px;
  /*background: #ebeff3;*/
  box-shadow: inset 10px 0 10px -8px #ebeff3;
  display: flex;
  flex-direction: column;

  /*&.sidebar-closed {*/
  /*    background: #ebeff3;*/
  /*}*/
}

.property-editor label {
  font-size: 12px;
}

.top-section {
  flex-grow: 1;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    display: none;
  }
}

.agent-label-wrapper {
  display: flex;
}

.agent-label-wrapper .left {
  flex-grow: 1;
  display: flex;
  align-items: center;
}

.agent-label-wrapper .right {
  flex-grow: 0;
  padding-left: 5px;
  display: flex;
  // align-items: center;
}

.agent-label-wrapper .right a.transfer-office {
  font-size: 11px;
  color: #007bff;
  text-decoration: none;
}
</style>
